<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Operation Report</h4>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/2 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Client ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.client_id"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Warehouse ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.warehouse_id"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Type
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                width="100%"
                                v-model="data.type"
                                autocomplete
                                multiple
                            >
                                <vs-select-item value="1" text="Good Receiving"/>
                                <vs-select-item value="2" text="Delivery Order"/>
                                <vs-select-item value="3" text="Value Added Service"/>
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Operators
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-select
                                class="selectExample"
                                v-model="data.operators"
                                width="100%"
                                autocomplete
                                multiple
                            >
                                <vs-select-item v-for="(item, index) in operators" :key="index" :value="item.id" :text="item.name"/>
                            </vs-select>
                        </div>
                    </div>
                    <br>
                    <vs-button class="btn mb-4 md:mb-0 mr-1" icon="import_export" @click="exportData">Export</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import { saveAs } from "file-saver";

export default {
    data() {
        return {
            isLoading: false,
            data: {
                operators: [],
                type: [],
                client_id: '',
                warehouse_id: 'FC Mekarsari'
            },
            operators: []
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        fetchData() {
            this.isLoading = true;

            this.$http.get('master/operators/all').then(res => {
                this.operators = res.data;
                this.isLoading = false;
            })
            .catch(e => this.handleError(e))
        },
        exportData() {
            this.isLoading = true;
            this.$http.post('report/operation', this.data, { responseType: "blob" })
            .then(response => {
                this.isLoading = false;
                var blob = new Blob([response.data], {
                    type: "application/pdf"
                });
                
                saveAs(blob, "operation_report_export.xlsx");
            })
            .catch(e => this.handleError(e, true));
        }
    },
    mounted() {
        this.fetchData();
    },
};
</script>